export default "__VITE_ASSET__BX$MEMRG__"